(() => {
  const option = 'A';

  const root = document.documentElement;
  root.dataset.iyrsCollectionOption = option;

  if (root.dataset.iyrsT5b3FiltersBound !== 'true') {
    document.addEventListener('input', (event) => {
      const control = event.target.closest?.('[data-iyrs-normalized-control]');
      if (!control) return;
      control.closest('[data-iyrs-filter-key]')?.querySelectorAll('[data-iyrs-filter-alias]').forEach((alias) => {
        alias.checked = control.checked;
      });
    }, true);

    document.addEventListener('click', (event) => {
      const removeButton = event.target.closest?.('[data-iyrs-remove-filter-group]');
      if (!removeButton) return;
      event.preventDefault();
      const key = removeButton.dataset.iyrsRemoveFilterGroup;
      const group = document.querySelector(`[data-iyrs-filter-key="${CSS.escape(key)}"]`);
      const control = group?.querySelector('[data-iyrs-normalized-control]');
      if (!control) return;
      control.checked = false;
      group.querySelectorAll('[data-iyrs-filter-alias]').forEach((alias) => { alias.checked = false; });
      control.dispatchEvent(new Event('input', { bubbles: true }));
    });

    root.dataset.iyrsT5b3FiltersBound = 'true';
  }

  const configureCollection = () => {
    const section = document.querySelector('.facest-filters-section');
    if (!section) return;
    section.dataset.iyrsCollectionOption = option;

    const sidebar = section.querySelector('.m-sidebar');
    const filterLabel = section.querySelector('.m-sidebar--open span');
    const sortLabel = section.querySelector('.m-sortby--open span');
    if (filterLabel) filterLabel.textContent = 'FILTER';
    if (sortLabel) sortLabel.textContent = 'SORT';

    section.querySelector('.m-sidebar--open')?.setAttribute('aria-label', 'Open collection filters');
    section.querySelector('.m-sortby--open')?.setAttribute('aria-label', 'Open collection sorting');

    section.querySelectorAll('.iyrs-t4-card').forEach((card) => {
      const handle = String(card.dataset.productHandle || '').toLowerCase();
      const title = String(card.querySelector('h3')?.textContent || '').toLowerCase();
      const visiblePrimary = card.querySelector('.iyrs-t4-card__image--primary');
      if (!visiblePrimary) return;
      let crop = 'long-hair-model';
      if (handle.includes('bob') || title.includes(' bob ')) crop = 'bob-model';
      else if (/(curly|curl|wave)/.test(`${handle} ${title}`)) crop = 'curly-volume-model';
      visiblePrimary.classList.add(`iyrs-t5b-crop--${crop}`);
    });

    if (section.dataset.iyrsT5bControlsBound !== 'true') {
      const showOverlayState = () => root.classList.add('iyrs-t5b-overlay-open');
      const clearOverlayState = () => root.classList.remove('iyrs-t5b-overlay-open');
      section.querySelector('.m-sidebar--open')?.addEventListener('click', showOverlayState);
      section.querySelector('.m-sidebar--close')?.addEventListener('click', clearOverlayState);
      sidebar?.addEventListener('click', (event) => {
        if (event.target === sidebar) clearOverlayState();
      });
      section.querySelector('.m-sortby--open')?.addEventListener('click', showOverlayState);
      document.querySelector('.m-sortby-mobile--close')?.addEventListener('click', clearOverlayState);
      document.querySelector('.m-sortby-mobile--wrapper')?.addEventListener('click', (event) => {
        if (event.target === event.currentTarget) clearOverlayState();
      });
      document.querySelectorAll('.m-sortby-mobile--item').forEach((item) => item.addEventListener('click', clearOverlayState));
      section.dataset.iyrsT5bControlsBound = 'true';
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', configureCollection, { once:true });
  else configureCollection();

  window.addEventListener('load', () => {
    if (window.MinimogEvents?.subscribe) window.MinimogEvents.subscribe('ON_PRODUCT_LIST_UPDATED', configureCollection);
  }, { once:true });
  document.addEventListener('collection:rerendered', configureCollection);
})();
